module.exports = __webpack_public_path__ + "img/home-bg5-m.1bc9ebc8.png";